import { render } from "./ReportsSalesProfitabilityTable.vue?vue&type=template&id=23a692c4"
import script from "./ReportsSalesProfitabilityTable.vue?vue&type=script&lang=js"
export * from "./ReportsSalesProfitabilityTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__